import React from 'react'
import {useRoutes} from "react-router-dom"
import BaseLayout from '@/layouts/BaseLayout'
import LazyLoading from '@/components/LazyLoading'

let lazyload=(path)=>{
  let Com=React.lazy(()=>{
    return new Promise(resolve => {
      setTimeout(() => {
        // 模拟网络请求或高计算负载
        import(`../pages/${path}`).then(module => {
          resolve(module);
        });
      }, /\/pages\/OrderManage\//.test(path) ? 0 : 0); // 设置延时为1000毫秒
    });
    // return import (`../pages/${path}`)
  })
  return (
    <React.Suspense fallback={<LazyLoading />}>
      <Com/>
    </React.Suspense>
  )
}

const routes = [
  {
    path: '/',
    element: <BaseLayout />,
    children: [
      {
        path: '/',
        element: lazyload('Home')
      },{
        path: '/category/:id',
        element: lazyload('Category')
      },{
        path: '/product/:id',
        element: lazyload('Product')
      },{
        path: '/product/detail/:id',
        element: lazyload('Product/Detail')
      },{
        path: '/news',
        element: lazyload('News')
      },{
        path: '/news/:id',
        element: lazyload('News/Detail')
      },{
        path: '/news/update/:id',
        element: lazyload('News/UpdateDetail')
      },{
        path: '/support',
        element: lazyload('Support')
      },{
        path: '/aboutus/companyoverview',
        element: lazyload('AboutUs/CompanyOverview')
      },{
        path: '/aboutus/team',
        element: lazyload('AboutUs/Team')
      },{
        path: '/aboutus/technology',
        element: lazyload('AboutUs/Technology')
      },{
        path: '/aboutus/medelipark',
        element: lazyload('AboutUs/MedeliPark')
      },{
        path: '/contactus',
        element: lazyload('ContactUs')
      },{
        path: '/dealer/distributor',
        element: lazyload('Dealer/Distributor')
      }
    ]
  },
  {
    path: '/login',
    element: lazyload('Login')
  },
]

const Router = () => {
  return useRoutes(routes)
}

export default Router
